import { status } from '../../config.ts'
import { wait } from '@/__mocks__/util/async.ts'
import {
  branchOfficesPage1,
  branchOfficeUsersPage1
} from '@/__mocks__/modules/branchOffices/data.ts'

export default [
  {
    method: 'GET',
    path: '/branch-offices/active',
    reply: async () => {
      await wait(5000)
      return [status.ok, branchOfficesPage1]
    }
  },
  {
    method: 'GET',
    path: '/branch-offices/catalog',
    reply: async () => {
      await wait()
      return [status.ok, branchOfficesPage1]
    }
  },
  {
    method: 'GET',
    path: '/branch-offices/1/users?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, branchOfficeUsersPage1]
    }
  },
  {
    method: 'GET',
    path: '/branch-offices/1/qr',
    reply: async () => {
      await wait()
      return [status.ok, 'mock-qr-branch-office-1']
    }
  }
]
